import React from 'react';

function PaginationControls({ pageCount, currentPage, onPageChange }) {
  const handlePreviousClick = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < pageCount - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (page) => {
    onPageChange(page);
  };

  // Generate page numbers array
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (pageCount <= maxVisiblePages) {
      for (let i = 0; i < pageCount; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
      let end = Math.min(pageCount - 1, start + maxVisiblePages - 1);

      if (end === pageCount - 1) {
        start = Math.max(0, end - maxVisiblePages + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex items-center justify-center gap-2 mt-8 mb-4">
      {/* Previous Button */}
      <button
        onClick={handlePreviousClick}
        disabled={currentPage === 0}
        className="group relative flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        style={{
          backgroundColor: currentPage === 0 ? 'var(--surface)' : 'var(--surface)',
          border: '2px solid var(--border)',
          color: 'var(--text)',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)'
        }}
        onMouseEnter={(e) => {
          if (currentPage > 0) {
            e.currentTarget.style.backgroundColor = 'var(--primary)';
            e.currentTarget.style.borderColor = 'var(--primary)';
            e.currentTarget.style.color = 'white';
            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
          }
        }}
        onMouseLeave={(e) => {
          if (currentPage > 0) {
            e.currentTarget.style.backgroundColor = 'var(--surface)';
            e.currentTarget.style.borderColor = 'var(--border)';
            e.currentTarget.style.color = 'var(--text)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
          }
        }}
      >
        <svg className="w-4 h-4 transition-transform duration-300 group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        <span className="font-semibold text-sm">Previous</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center gap-1">
        {pageNumbers.map((page) => (
          <button
            key={page}
            onClick={() => handlePageClick(page)}
            className="relative w-10 h-10 rounded-xl font-semibold text-sm transition-all duration-300 hover:scale-110"
            style={{
              backgroundColor: page === currentPage ? 'var(--primary)' : 'var(--surface)',
              border: '2px solid var(--border)',
              color: page === currentPage ? 'white' : 'var(--text)',
              boxShadow: page === currentPage ? '0 8px 25px rgba(0, 0, 0, 0.15)' : '0 4px 15px rgba(0, 0, 0, 0.05)'
            }}
            onMouseEnter={(e) => {
              if (page !== currentPage) {
                e.currentTarget.style.backgroundColor = 'var(--primary-light)';
                e.currentTarget.style.borderColor = 'var(--primary)';
                e.currentTarget.style.color = 'var(--primary)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
              }
            }}
            onMouseLeave={(e) => {
              if (page !== currentPage) {
                e.currentTarget.style.backgroundColor = 'var(--surface)';
                e.currentTarget.style.borderColor = 'var(--border)';
                e.currentTarget.style.color = 'var(--text)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
              }
            }}
          >
            {page + 1}
          </button>
        ))}
      </div>

      {/* Next Button */}
      <button
        onClick={handleNextClick}
        disabled={currentPage === pageCount - 1}
        className="group relative flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        style={{
          backgroundColor: currentPage === pageCount - 1 ? 'var(--surface)' : 'var(--surface)',
          border: '2px solid var(--border)',
          color: 'var(--text)',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)'
        }}
        onMouseEnter={(e) => {
          if (currentPage < pageCount - 1) {
            e.currentTarget.style.backgroundColor = 'var(--primary)';
            e.currentTarget.style.borderColor = 'var(--primary)';
            e.currentTarget.style.color = 'white';
            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
          }
        }}
        onMouseLeave={(e) => {
          if (currentPage < pageCount - 1) {
            e.currentTarget.style.backgroundColor = 'var(--surface)';
            e.currentTarget.style.borderColor = 'var(--border)';
            e.currentTarget.style.color = 'var(--text)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
          }
        }}
      >
        <span className="font-semibold text-sm">Next</span>
        <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}

export default PaginationControls;
